import notificationPanel from './notification-panel.vue'
import {module} from "@/plugins/notification-panel/module";

const components = [
  notificationPanel
];

export default {
  install(app, options) {

    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }

    options.store.registerModule('notify', module)

    components.forEach((e) => {
      app.component(e.name, e);
    });

    app.prototype.$notify = {

      success(message) {
        options.store.commit('notify/ADD_NOTIFICATION', {
          'type': 'success',
          'message': message,
          'title': 'Success'
        })
      },

      error(message) {
        options.store.commit('notify/ADD_NOTIFICATION', {
          'type': 'error',
          'message': message,
          'title': 'Error occurred'
        })
      }

    }
  }
};